
<template>
    <div>
        <div style="border: 1px solid #e9e9e9; border-radius: 1rem;">
            <q-card-section>
                <div class="text-bold" style="font-size: 16px;">{{$t("stepper.title8")}}</div>
            </q-card-section>
            <q-separator style="margin: 0 0.75rem; width: auto;"/>
            <q-card-section>
                <div class="q-pb-md secondaryHeader" >
                   {{$t("Employment-Detail.title")}}
                </div>
                <div class="row">
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                        {{$t("Employment-Detail.empstatus")}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md q-pr-md">
                        {{StoreStateED.EmploymentStatus}}
                    </div>
                    <!-- Xp said need reason if 'unemployed' selected -->
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                        {{$t("Employment-Detail.designation")}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md">
                        {{StoreStateED.Designation?StoreStateED.Designation:'-'}}
                    </div>
                </div>
                <div class="row  ">
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                        {{$t("Employment-Detail.businessnature")}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md q-pr-md">
                        {{StoreStateED.BusinessNature?StoreStateED.BusinessNature:'-'}}
                    </div>
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                        {{$t("Employment-Detail.businessnature2")}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md">
                        {{StoreStateED.BusinessNatureOther?StoreStateED.BusinessNatureOther:'-'}}
                    </div>
                </div>

                <q-separator style="margin-bottom: 16px; margin-top: 16px;"/>

                <div class="q-pb-md secondaryHeader" >
                   {{$t("Employment-Detail.employerdetails")}}
                </div>

                <div class="row  q-pb-md">
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                        {{$t("Employment-Detail.employername")}}
                    </div>
                    <div class="col-xs-12 col-md-9 ">
                        {{StoreStateED.EmployerName?StoreStateED.EmployerName:'-'}}
                    </div>
                </div>
                
                

                <div class="row  q-pb-md">
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                        <!-- {{$t("Employment-Detail.address")}} -->
                        {{$t("Employment-Detail.employeradd")}}
                    </div>
                    <div class="col-xs-12 col-md-9 ">
                        {{StoreStateED.EmployerAddress.Address1?StoreStateED.EmployerAddress.Address1:'-'}}
                    </div>
                </div>
            </q-card-section>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import store from '../store'
export default {
    name : 'SummaryEmploymentInformation',
    data() {
        return {
            StoreStateAOD : store.state.AOD,
            StoreStateED  : store.state.ED
        }
    },
    computed: {

    },
    methods: {

    }
}
</script>